__turbopack_context__.v({
  "communityMetricsTable": "Home-module-scss-module__Mg1cZq__communityMetricsTable",
  "hideWidget": "Home-module-scss-module__Mg1cZq__hideWidget",
  "htmlContainer": "Home-module-scss-module__Mg1cZq__htmlContainer",
  "instructionsLink": "Home-module-scss-module__Mg1cZq__instructionsLink",
  "latestDropImage": "Home-module-scss-module__Mg1cZq__latestDropImage",
  "login": "Home-module-scss-module__Mg1cZq__login",
  "loginImage": "Home-module-scss-module__Mg1cZq__loginImage",
  "loginPrompt": "Home-module-scss-module__Mg1cZq__loginPrompt",
  "main": "Home-module-scss-module__Mg1cZq__main",
  "marketplace": "Home-module-scss-module__Mg1cZq__marketplace",
  "memeLabHeader": "Home-module-scss-module__Mg1cZq__memeLabHeader",
  "nextGenQuestion": "Home-module-scss-module__Mg1cZq__nextGenQuestion",
  "nftImagePadding": "Home-module-scss-module__Mg1cZq__nftImagePadding",
  "shadowBox": "Home-module-scss-module__Mg1cZq__shadowBox",
  "tdhFormula": "Home-module-scss-module__Mg1cZq__tdhFormula",
  "viewAllLink": "Home-module-scss-module__Mg1cZq__viewAllLink",
});
